"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for forbidden responses for operations on users
 * @param {string} userId the user id the operation is performed on
 */
class ForbiddenUserOperationError extends client_library_1.ExtendableError {
    constructor(userId) {
        super(`Forbidden operation on user ${userId}`);
        this.userId = userId;
    }
}
exports.default = ForbiddenUserOperationError;
